import { Injectable, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { Observable, throwError } from "rxjs";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { LoadingService } from './loading.service';
import axios from 'axios';
import pako from 'pako';
import { SocialProfileTypeEnum } from '../enums/social-profile-type.enum';

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public hasChosen: boolean = false;
  public isAgent: boolean = true;
  public agentData: Array<any> = [];
  public countriesCount: number = 0;
  public filteredData: Array<any> = [];
  public viewsPerPage: number = 10;
  public showAdvanced: boolean = true;
  public anyData: boolean = false;
  public hasLoaded: boolean = false;
  public searchTimeout: any = null;
  public syncTimeout: any = null;
  public pageUrl: string = "home";
  public searchAppliedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  public agentFilters: any = {
    "normal": [
      {
        "key": "OrganisationName",
        "name": "Organisation name"
      },
      {
        "key": "CountryName",
        "name": "Country/territory served",
        "hardFilter": true
      },
      {
        "key": "Lastname",
        "name": "Surname/family name",
        "type": "Text"
      }
    ],
    "advanced": [
      {
        "key": "City",
        "name": "Physical office location",
        "hardFilter": true
      },
      {
        "key": "EducationList",
        "name": "Education level",
        "isArray": true
      },
      //{
      //  "key": "HasPhysicalOffice",
      //  "name": "Physical Office"
      //},
      {
        "key": "LanguagesList",
        "name": "Language",
        "isArray": true
      },
      {
        "key": "JobRoleTypeDescription",
        "name": "Roles",
        "isHidden": true
      },
      {
        "key": "CountryName",
        "name": "Country/territory served",
        "collapsed": true,
        "hardFilter": true
      },
      {
        "key": "StateName",
        "name": "Regions/states/devolved areas/autonomous regions",
        "hardFilter": true,
      },
      {
        "key": "OrganisationName",
        "name": "Organisation",
        "collapsed": true
      },
    ]
  };

  public counsellorFilters: any = {
    "normal": [
      {
        "key": "EducationProviderName",
        "name": "Education provider name"
      },
      {
        "key": "CountryName",
        "name": "Country/territory"
      }
    ],
    "advanced": [
      {
        "key": "City",
        "name": "City/Town",
        "hardFilter": true,
        "reqFilter": "CountryName"
      },
      {
        "key": "JobRoleTypeDescription",
        "name": "Roles",
        "isHidden": true
      },
      {
        "key": "CountryName",
        "name": "Country/territory served",
        "collapsed": true,
        "hardFilter": true,
        "isHidden": true
      },
      {
        "key": "StateName",
        "name": "Regions/states/devolved areas/autonomous regions",
        "hardFilter": true,
        "reqFilter": "CountryName"
      },
      {
        "key": "OrganisationName",
        "name": "Organisation",
        "collapsed": true,
        "hardFilter": true
      },
    ]
  };

  public textSearchData: any = {};
  public searchData: any = {};
  public filteredSearchData: any = {};
  public filterData: any = {};
  public topLevelFilter: any = {};

  public syncReference: any = {};
  public syncReferenceReverse: any = {};

  constructor(
    public http: HttpClient,
    public loadingSvc: LoadingService
  ) {
    this.syncFilters();
    this.loadData();

    /*setInterval(() => {
      this.syncFilters();
    }, 500);*/
  }

  syncFilters() {
    var jobRoleDescription = this.filterData.JobRoleTypeDescription;
    this.agentFilters.normal.forEach(filter => {
      if (this.searchData[filter.key] == null || this.searchData[filter.key] == undefined) {
        this.textSearchData[filter.key] = "";
        this.searchData[filter.key] = [];
        this.filteredSearchData[filter.key] = [];
        this.filterData[filter.key] = [];
        this.topLevelFilter[filter.key] = [];
      }
    });
    this.agentFilters.advanced.forEach(filter => {
      if (this.searchData[filter.key] == null || this.searchData[filter.key] == undefined) {
        this.textSearchData[filter.key] = "";
        this.searchData[filter.key] = [];
        this.filteredSearchData[filter.key] = [];
        this.filterData[filter.key] = [];
        this.topLevelFilter[filter.key] = [];
      }
    });
    this.counsellorFilters.normal.forEach(filter => {
      if (this.searchData[filter.key] == null || this.searchData[filter.key] == undefined) {
        this.textSearchData[filter.key] = "";
        this.searchData[filter.key] = [];
        this.filteredSearchData[filter.key] = [];
        this.filterData[filter.key] = [];
        this.topLevelFilter[filter.key] = [];
      }
    });
    this.counsellorFilters.advanced.forEach(filter => {
      if (this.searchData[filter.key] == null || this.searchData[filter.key] == undefined) {
        this.textSearchData[filter.key] = "";
        this.searchData[filter.key] = [];
        this.filteredSearchData[filter.key] = [];
        this.filterData[filter.key] = [];
        this.topLevelFilter[filter.key] = [];
      }
    });
    this.agentFilters.normal.forEach(filter => {
      this.syncCategory(filter.key);
      this.syncCategoryReverse(filter.key);
      this.applyDependencies(filter, this.agentFilters, "City", "CountryName");
      this.applyDependencies(filter, this.agentFilters, "StateName", "CountryName");
    });
    this.agentFilters.advanced.forEach(filter => {
      this.syncCategory(filter.key);
      this.syncCategoryReverse(filter.key);
    });
    this.counsellorFilters.normal.forEach(filter => {
      this.syncCategory(filter.key);
      this.syncCategoryReverse(filter.key);
      this.applyDependencies(filter, this.counsellorFilters, "City", "CountryName");
      this.applyDependencies(filter, this.counsellorFilters, "StateName", "CountryName");
    });
    this.counsellorFilters.advanced.forEach(filter => {
      this.syncCategory(filter.key);
      this.syncCategoryReverse(filter.key);
    });
    this.filterData.JobRoleTypeDescription = jobRoleDescription;
  }

  applyDependencies(filter: any, contextFilters: any, source: string, target: string) {
    if (filter.key == target) {
      if (this.filterData[target] !== undefined && this.filterData[target] !== null) {
        for (var i = 0; i < contextFilters.advanced.length; i++) {
          if (contextFilters.advanced[i].key == source) {
            contextFilters.advanced[i].isHidden = this.filterData[filter.key].length === 0;
            if (contextFilters.advanced[i].isHidden) {
              this.searchData[source].forEach(item => {
                item.value = false;
              });
            }
          }
        }
      }
    }
  }

  applySearch(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.filteredData = [];
      this.applySearchItems();
      this.loadFilteredSearchData();
      this.searchAppliedEmitter.emit(true);
      resolve(true);
    });
  }

  constructFilterItem(filter: any) {
    if (filter.type == null || filter.type == undefined) {
      var filterData = this.filterData[filter.key];
      return ({
        "key": filter.key,
        "data": filterData,
        "filter": filter
      })
    } else {
      var filterData = this.textSearchData[filter.key];
      return ({
        "key": filter.key,
        "value": filterData,
        "filter": filter
      })
    }
  }

  applySearchItems() {
    var filterToApply = [];

    this.agentFilters.normal.forEach(filter => {
      filterToApply.push(this.constructFilterItem(filter));
    });
    this.agentFilters.advanced.forEach(filter => {
      filterToApply.push(this.constructFilterItem(filter));
    });
    this.counsellorFilters.normal.forEach(filter => {
      filterToApply.push(this.constructFilterItem(filter));
    });
    this.counsellorFilters.advanced.forEach(filter => {
      filterToApply.push(this.constructFilterItem(filter));
    });

    this.agentData.forEach(agent => {
      var any = false;
      var flags = [];

      filterToApply.forEach(filter => {
        if (filter.filter.type == null || filter.filter.type == undefined) {
          if (filter.filter.isArray != null && filter.filter.isArray != undefined) {
            var hasData = (filter.data.length > 0 ? (filter.data.filter(x => agent[filter.key].filter(x2 => this.tidyValue(x2) == this.tidyValue(x.name)).length > 0).length > 0) : true);
            flags.push(hasData);
          } else {
            var hasData = (filter.data.length > 0 ? (filter.data.filter(x => this.tidyValue(x.name) == this.tidyValue(agent[filter.key])).length > 0) : true);
            flags.push(hasData);
          }
        } else {
          var hasData = true;
          try {
            var keyValue = agent[filter.key].toString().toLowerCase();
            var lookupValue = filter.value.toString().toLowerCase();
            hasData = keyValue.indexOf(lookupValue) !== -1;
          } catch (e) {
            // 
          }
          flags.push(hasData);
        }
      });



      if (flags.filter(x => x == false).length == 0)
        any = true;

      if (this.filteredData.filter(x => x.UserId == agent.UserId).length > 0)
        any = false;
      if (any)
        this.filteredData.push(agent);
    });
  }

  applySearchitem(item, variable) {
    var items = this.filterData[item];
    if (items.length == 0)
      return false;
    this.agentData.forEach(agent => {
      var any = false;
      var val = this.tidyValue(agent[variable]);

      if (items.filter(x => x.name == val).length > 0)
        any = true;
      if (this.filteredData.filter(x => x.UserId == agent.UserId).length > 0)
        any = false;
      if (any)
        this.filteredData.push(agent);
    });
    return true;
  }

  syncCategoryReverse(category: string) {
    var syncJson = this.syncReferenceReverse[category];
    var filterJson = JSON.stringify(this.filterData[category]) + JSON.stringify(this.textSearchData[category]);

    if (syncJson != undefined ? (syncJson.length != filterJson.length) : true) {
      var arr = [];
      for (let obj of this.filterData[category]) {
        arr.push(obj);
      }
      this.topLevelFilter[category] = [];
      this.searchData[category].forEach(s => {
        var any = false;
        for (let obj of arr) {
          if (s.name == obj.name) {
            any = true;
            break;
          }
        }
        s.value = any;
      });

      var searchJson = JSON.stringify(this.searchData[category]);
      this.syncReferenceReverse[category] = filterJson;
      this.syncReference[category] = searchJson;
    }
  }

  syncCategory(category: string) {
    var syncJson = this.syncReference[category];
    var searchJson = JSON.stringify(this.searchData[category]);

    
    if (syncJson != undefined ? (syncJson.length != searchJson.length) : true) {
      this.searchData[category].forEach(s => {
        this.filterData[category] = this.filterData[category].filter(x => x.name != s.name);
        if (s.value == true) {
          this.filterData[category].push(s);
        }
      });

      var filterJson = JSON.stringify(this.filterData[category]);

      this.syncReferenceReverse[category] = filterJson;
      this.syncReference[category] = searchJson;
    }
  }

  parseIsoDateStrToDate(key, value) {
    var isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;
    if (key == "CertifiedDate") {
      const re = /-?\d+/;
      const m = re.exec(value);
      var v = parseInt(m[0], 10);
      return new Date(v);
    }
    return value
  }

  getDateFromAspNetFormat(date: string): number {
    const re = /-?\d+/;
    const m = re.exec(date);
    return parseInt(m[0], 10);
  }

  async fetchGzipJSON(url: string) {
    let inflatedJSON = {};
    try {
      const { data } = await axios.get(url, {
        responseType: 'arraybuffer',
        decompress: true,
      });
      inflatedJSON = JSON.parse(pako.inflate(data, { to: 'string' }));
    } catch (error) {
      console.error('could not fetch gzip json', error);
    }
    return inflatedJSON;
  };

  loadData() {
    this.loadingSvc.changeLoading("data.loadData", true);

    setTimeout(() => {
      this.http.get("https://enetcloud-britishcouncil-live-acts.azurewebsites.net/Public/GetAgentUsers").subscribe(async (r: any) => {
        var url = r.Url;
        var d = await this.fetchGzipJSON(url);
        var strData = JSON.stringify(d);
        var cData = JSON.parse(strData, this.parseIsoDateStrToDate);
        this.agentData = cData;
        this.filteredData = this.agentData;
        this.unpackSerialisedVariables();
        this.anyData = this.agentData.length > 0;
        this.countriesCount = [...new Set(this.agentData.map(x => x.CountryName).filter(x => x != undefined))].length; 

        this.loadingSvc.isBusy = false;
        this.loadSearchData();
        this.loadingSvc.changeLoading("data.loadData.success", false);
        this.hasLoaded = true;
      }, (err) => {
        this.hasLoaded = true;
        console.error(err);
        this.loadingSvc.changeLoading("data.loadData.error", false);
      });
    }, 0);
  }

  unpackSerialisedVariables() {
    for (var i = 0; i < this.filteredData.length; i++) {
      var item = this.filteredData[i];

      // The serialized JSON has numbers to represent properties
      // we need to unpack them for ease of readability in this
      // app.
      item["UserId"] = item["1"];
      item["Firstname"] = item["2"];
      item["Lastname"] = item["3"];
      item["Fullname"] = item["4"];
      item["PayrollNo"] = item["5"];
      item["Avatar"] = item["6"];
      item["IsArchived"] = item["7"];
      item["CompetencyProgress"] = item["8"];
      item["TrainingProgress"] = item["9"];
      item["EventProgress"] = item["10"];
      item["CompetencyUserType"] = item["11"];
      item["Location"] = item["12"];
      item["Email"] = item["13"];
      item["LocationId"] = item["14"];
      item["JobRoleId"] = item["15"];
      item["JobRoleName"] = item["16"];
      item["JobRoleTypeDescription"] = item["17"];
      item["Gender"] = item["18"];
      item["Languages"] = item["19"];
      //item["LanguagesList"] = item["20"];
      item["LanguagesList"] = item["19"] && item["19"].length > 0 && item["19"].charAt(0) == "," 
        ? item["19"].substring(1).split(",") 
        : (item["19"] ? item["19"].split(",") : []); //new languages list -> string to array
      item["EducationProviderName"] = item["21"];
      item["CountryId"] = item["25"];
      item["CountryName"] = item["26"];
      item["City"] = item["32"];
      item["Address1"] = item["36"].replace("|NOT|", "");
      item["Address2"] = item["37"];
      item["Address3"] = item["38"];
      item["OrganisationName"] = item["22"];
      item["BritishCouncilPartnerSchool"] = item["34"];
      item["HasPhysicalOffice"] = item["35"];
      item["AdditionFarms"] = item["60"] && item["60"].length > 0 && item["60"].charAt(0) == "," 
        ? item["60"].substring(1).split(",") 
        : (item["60"] ? item["60"].split(",") : []);
      item["CertifiedDate"] = item["61"];
      item["WorksWithElt"] = item["62"];
      item["WorksWithHe"] = item["63"];
      item["WorksWithInd"] = item["64"];
      item["WorksWithPathway"] = item["65"];
      item["EducationList"] = item["66"];
      item["HasLinkedIn"] = item["67"];
      item["LinkedInProfileName"] = item["68"];
      item["LinkedInUrl"] = item["69"];
      item["School"] = item["70"];
      item["UserDepartments"] = item["71"];
      item["ExternalReference"] = item["72"];
      item["StateId"] = item["73"];
      item["StateName"] = this.unicodeToChar(item["74"]);
      item["LocationStateId"] = item["77"];
      item["LocationStateName"] = this.unicodeToChar(item["78"]);
      this.getOrganisationInfoFromXML(item, item["79"]);
      this.getSocialsInfoFromXML(item, item["80"]);

      // 78 = max index for properties, in this case LocationStateName
      for (var j = 1; j < 80; j++) {
        delete item[j.toString()];
      }
    }
  }

  getFiltersArrays(): any[] {
    return this.agentFilters.normal.concat(
      this.agentFilters.advanced.concat(
        this.counsellorFilters.normal.concat(
          this.counsellorFilters.advanced
        )
      )
    );
  }

  loadSearchData() {
    this.loadingSvc.changeLoading("data.loadSearchData", true);

    const filters = this.getFiltersArrays();
    var searchDataResult = this.processArrayDynamicValueWithFilters(filters);
    for (let sd of searchDataResult) {
      this.searchData[sd.key] = sd.values;
    }
    setTimeout(() => {
      this.loadingSvc.changeLoading("data.loadSearchData.timeout", false);
    }, 500);
  }

  loadFilteredSearchData() {
    this.loadingSvc.changeLoading("data.loadFilteredSearchData", true);
    const filters = this.getFiltersArrays();

    var filteredDataResult = this.processFilteredArrayDynamicValueWithFilters(filters);
    for (let fd of filteredDataResult) {
      this.filteredSearchData[fd.key] = fd.values;
    }
    setTimeout(() => {
      if (!this.loadingSvc.isBusy)
        this.loadingSvc.changeLoading("data.loadFilteredSearchData.timeout", false);
    }, 500);
  }

  tidyValue(val) {
    if (val != null && val != undefined) {
      var tempval = val.toString().trim();
      if (tempval == "false")
        val = "No";
      if (tempval == "true")
        val = "Yes";
    }
    return val;
  }

  processFilteredArrayDynamicValue(property): Array<any> {
    return this.processArrayDynamicValueGeneric(this.filteredData, property);
  }

  processArrayDynamicValue(property): Array<any> {
    return this.processArrayDynamicValueGeneric(this.agentData, property);
  }

  processArrayDynamicValueGeneric(list: any, filter: any): Array<any> {
    var arr = [];
    list.forEach(agent => {
      if (filter.isArray == null || filter.isArray == undefined) {
        var val = this.tidyValue(agent[filter.key]);
        arr = this.appendToDynmicValueList(arr, val);
      } else {
        var l = agent[filter.key];
        if (l != null && l != undefined) {
          l.forEach(lItem => {
            var val = this.tidyValue(lItem);
            arr = this.appendToDynmicValueList(arr, val);
          });
        }
      }
    });
    arr = arr.filter(x => x.name != null && x.name != "");
    arr.sort((one, two) => (one.name.toString().trim().toLowerCase() > two.name.toString().trim().toLowerCase() ? 1 : -1));
    return arr;
  }

  processArrayDynamicValueWithFilters(filters: any[]): Array<any> {
    return this.processArrayDynamicValueGenericWithFilters(this.agentData, filters);
  }

  processFilteredArrayDynamicValueWithFilters(filters: any[]): Array<any> {
    return this.processArrayDynamicValueGenericWithFilters(this.filteredData, filters);
  }

  processArrayDynamicValueGenericWithFilters(list: any, filters: any[]): Array<any> {
    const arrFiltersKeys = [...new Set(filters.filter(x => x.isArray !== null && x.isArray !== undefined).map(x => x.key))];
    const simpleFiltersKeys = [...new Set(filters.filter(x => !x.isArray).map(x => x.key))];
    var searchData: any[] = [];
    list.forEach(agent => {
      for(let simpleFilter of simpleFiltersKeys) {
        let arr = searchData.find(x => x.key && x.key == simpleFilter);
        if(!arr){
          searchData.push({
            key: simpleFilter,
            values: []
          });
          arr = searchData.find(x => x.key && x.key == simpleFilter);
        }

        var val = this.tidyValue(agent[simpleFilter]);
        if(val != null && val != "") arr.values = this.appendToDynmicValueList(arr.values, val);
      }

      for(let arrFilter of arrFiltersKeys) {
        let arr = searchData.find(x => x.key && x.key == arrFilter);
        if(!arr){
          searchData.push({
            key: arrFilter,
            values: []
          });
          arr = searchData.find(x => x.key && x.key == arrFilter);
        }
        var l = agent[arrFilter];
        if (l != null && l != undefined) {
          this.appendToDynmicValueArrayList(arr.values, l.map(x => this.tidyValue(x)).filter(x => x != null && x !== ""));
        }
      }
    });
    for (let sd of searchData){
      sd.values.sort((one, two) => (one.name.toString().trim().toLowerCase() > two.name.toString().trim().toLowerCase() ? 1 : -1));
    }
    return searchData;
  }

  appendToDynmicValueList(arr: Array<any>, val: string): Array<any> {
    var arrValue = arr.find(x => x.name == val);
    if (!arrValue) {
      arr.push({
        "name": val,
        "value": false,
        "count": 1
      });
    } else {
      arrValue.count++;
    }
    return arr;
  }
  
  appendToDynmicValueArrayList(arr: Array<any>, val: string[]): Array<any> {
    if(val.toString().trim() == "") return arr;

    for(let item of val) {
      var arrValue = arr.find(x => x.name === item);
      if (!arrValue) {
        arr.push({
          "name": item,
          "value": false,
          "count": 1
        });
      } else {
        arrValue.count++;
      }
    }

    
    return arr;
  }

  resetFilters() {
    this.processResetFilter(this.agentFilters.normal);
    this.processResetFilter(this.agentFilters.advanced);
    this.processResetFilter(this.counsellorFilters.normal);
    this.processResetFilter(this.counsellorFilters.advanced);
  }

  processResetFilter(arr: Array<any>) {
    arr.forEach(filter => {
      if (filter.type == null || filter.type == undefined) {
        this.filterData[filter.key] = [];
      } else if (filter.type == "Text") {
        this.textSearchData[filter.key] = "";
      }
    });
  }

  cleanFilters(type: string) {
    var agentFilters = this.agentFilters.normal;
    var counsellorFilters = this.counsellorFilters.normal;
    switch (type) {
      case "agent":
        this.compareFilters(counsellorFilters, agentFilters);
        break;
      case "counsellor":
        this.compareFilters(agentFilters, counsellorFilters);
        break;
    }
  }

  compareFilters(p1: any, p2: any) {
    p1.forEach((filter: any) => {
      var matchedFilters = p2.filter(x => x.key == filter.key);
      var any = matchedFilters.length > 0;
      if (!any) {
        if (filter.type == null || filter.type == undefined) {
          this.filterData[filter.key] = [];
        } else if (filter.type == "Text") {
          this.textSearchData[filter.key] = "";
        }
      }
    });
  }

  unicodeToChar(text) {
    if(!text) return null;
    return text.replace(/\\u[\dA-F]{4}/gi,
      function (match) {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
      });
  }

  getOrganisationInfoFromXML(item: any, xmlStr: string) {
    if (!xmlStr) return;
    const parser = new DOMParser();
    const organisationInfoXml = parser.parseFromString(xmlStr, "application/xml");
    let elOrgAddress1 = organisationInfoXml.querySelector("Address1");
    let elOrgAddress2 = organisationInfoXml.querySelector("Address2");
    let elOrgAddress3 = organisationInfoXml.querySelector("Address3");
    let elOrgJobTitle = organisationInfoXml.querySelector("JobTitle");
    let elOrgCity = organisationInfoXml.querySelector("City");
    let elOrgCountryId = organisationInfoXml.querySelector("CountryId");
    let elOrgCountryName = organisationInfoXml.querySelector("CountryName");
    let elOrgStateId = organisationInfoXml.querySelector("StateId");
    let elOrgStateName = organisationInfoXml.querySelector("StateName");
    let elOrgPhone = organisationInfoXml.querySelector("Phone");
    let elOrgPhoneCC = organisationInfoXml.querySelector("PhoneCC");
    let elOrgWebAddress = organisationInfoXml.querySelector("Webaddress");
    let elOrgEmail = organisationInfoXml.querySelector("Email");
    
    item["OrganisationPhone"] = elOrgPhone && elOrgPhone.textContent ? elOrgPhone.textContent : "";
    item["OrganisationPhoneCC"] = elOrgPhoneCC && elOrgPhoneCC.textContent ? elOrgPhoneCC.textContent : "";
    item["OrganisationCountryId"] = elOrgCountryId && elOrgCountryId.textContent ? Number(elOrgCountryId.textContent) : 0;
    item["OrganisationCountryName"] = elOrgCountryName && elOrgCountryName.textContent ? elOrgCountryName.textContent : "";
    item["OrganisationCity"] = elOrgCity && elOrgCity.textContent ? elOrgCity.textContent : "";
    item["OrganisationEmail"] = elOrgEmail && elOrgEmail.textContent ? elOrgEmail.textContent : "";
    item["OrganisationWebAddress"] = elOrgWebAddress && elOrgWebAddress.textContent ? elOrgWebAddress.textContent : "";
    item["OrganisationJobTitle"] = elOrgJobTitle && elOrgJobTitle.textContent ? elOrgJobTitle.textContent : "";
    item["OrganisationAddress1"] = elOrgAddress1 && elOrgAddress1.textContent && elOrgAddress1.textContent.length > 0 ? elOrgAddress1.textContent.replace("|NOT|", "") : "";      
    item["OrganisationAddress2"] = elOrgAddress2 && elOrgAddress2.textContent ? elOrgAddress2.textContent : "";
    item["OrganisationAddress3"] = elOrgAddress3 && elOrgAddress3.textContent ? elOrgAddress3.textContent : "";
    item["OrganisationStateId"] = elOrgStateId && elOrgStateId.textContent ? Number(elOrgStateId.textContent) : 0;
    item["OrganisationStateName"] = elOrgAddress1 && elOrgAddress1.textContent ? this.unicodeToChar(elOrgStateName.textContent) : "";
  }

  getSocialsInfoFromXML(item: any, xmlStr: string) {
    if (!xmlStr) return;
    const parser = new DOMParser();
    const socialsInfoXml = parser.parseFromString(xmlStr, "application/xml");
    let rows = socialsInfoXml.querySelectorAll("row");
    item["HasFacebook"] = false;
    item["HasTwitter"] = false;
    item["HasInstagram"] = false;
    item["HasWeibo"] = false;
    item["HasWeChat"] = false;
    item["HasOther"] = false;

    for (let i = 0; i < rows.length; i++) {
      let elProfileType = rows[i].querySelector("ProfileType");
      let elProfileName = rows[i].querySelector("ProfileName");
      let elProfileUrl = rows[i].querySelector("ProfileUrl");
      if(
        elProfileType && elProfileType.textContent && elProfileType.textContent.length > 0
        && elProfileName && elProfileName.textContent && elProfileName.textContent.length > 0
        && elProfileUrl && elProfileUrl.textContent && elProfileUrl.textContent.length > 0
        ) {
        let profileType = Number(elProfileType.textContent);
        switch(profileType) {
          case SocialProfileTypeEnum.Facebook:
            item["HasFacebook"] = true;
            item["FacebookProfileName"] = elProfileName.textContent;
            item["FacebookUrl"] = elProfileUrl.textContent;
            break;
          case SocialProfileTypeEnum.Twitter:
            item["HasTwitter"] = true;
            item["TwitterProfileName"] = elProfileName.textContent;
            item["TwitterUrl"] = elProfileUrl.textContent;
            break;
          case SocialProfileTypeEnum.Instagram:
            item["HasInstagram"] = true;
            item["InstagramProfileName"] = elProfileName.textContent;
            item["InstagramUrl"] = elProfileUrl.textContent;
            break;
          case SocialProfileTypeEnum.Weibo:
            item["HasWeibo"] = true;
            item["WeiboProfileName"] = elProfileName.textContent;
            item["WeiboUrl"] = elProfileUrl.textContent;
            break;
          case SocialProfileTypeEnum.Wechat:
            item["HasWeChat"] = true;
            item["WeChatProfileName"] = elProfileName.textContent;
            item["WeChatUrl"] = elProfileUrl.textContent;
            break;
          case SocialProfileTypeEnum.Other:
            item["HasOther"] = true;
            item["OtherProfileName"] = elProfileName.textContent;
            item["OtherUrl"] = elProfileUrl.textContent;
            break;
          default:
            break;
        }
      }
    }
  }
}